import { atom } from "kho";
import type { Object3D } from "three";

/**
 * The point-cloud scene containers (streamed + static) the surface sampler
 * reads to snap objects onto the terrain. The Viewer bridge publishes these;
 * the surface lib (SurfaceSampler / getPointCloudSurface) consumes them from
 * here rather than reaching into the Viewer's scene map — the store owns "what
 * the ground is". Same split as poc/editor data/cloud.ts.
 */
export const $cloudScenes = atom<Object3D[]>([]);
